import styled from 'styled-components'

interface IChatConversationStyledProps {}

export const ChatConversationStyled = styled.div<IChatConversationStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};

  position: relative;

  height: ${(props) => props.theme.typography.pxToRem(350)};

  overflow-x: hidden;
  overflow-y: auto;

  padding: ${(props) => props.theme.space.medium}
    ${(props) => props.theme.space.large};
`
